// @flow

// #region imports
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { List } from "@react-md/list";
import { Card } from "@react-md/card";
import Spinner from '../../../components/contentLoader/spinner';
import { withRouter } from 'shared/routing/withRouter';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import { Divider } from "@react-md/divider";
import {getPaymentURLToRedirect, storeRetailPrice, getPaymentOption, getAtomPaymentURL} from '../action';
import googlePay from "../../../assets/gpay.png"
import phonePay from "../../../assets/phone_pe.png"
import paytm from "../../../assets/paytm-720.png"
import upi from "../../../assets/bhim-720.png"
import debitCard from "../../../assets/Debit_Card1.png"
import online from "../../../assets/online-banking-ic.png"
import creditCard from "../../../assets/bank-card.png"
import payIcon from '../../../assets/ic_home_pay_white@1x.png'
import payViaUPI from '../../../assets/ic_upi_payment.png'

import { Avatar } from "@react-md/avatar";
import ErrorDialogBox from '../../../components/Common/dialogContainer';
import { getMessageFromApiError } from '../../../service/apiErrorMessage';

// #endregion
class PaymentOption extends React.Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    this.state={
      hasMounted: false,
      paymentHashKey: parsed.paymentHash ,
      paymentHashRedirectToCcaPost : parsed.PaymentHashToRedirctPaymentGate,
      selectedPayment:'',
      isLoad:false,
      totalAmount : parsed.totalAmount,
      shippingCharge : parsed.shippingCharge,
      deliveryKey : parsed.ReturnKey || parsed.returnKey,
      paymentErrorMsg: '',
      isPaymentErrorVisible: false,

    }
  }
  closePaymentErrorDialog = () => {
    this.setState({ paymentErrorMsg: '', isPaymentErrorVisible: false });
  };
  componentDidMount(){
    this.setState({ hasMounted: true });
    const { location } = this.props;
    const search = location.search;
    if(!search.includes('share=true')){
      this.setState({
        isLoad:true
      })
      var setModel = {
        "ValidatorKey":this.state.paymentHashKey == undefined ? this.props.paymentHashKey :this.state.paymentHashKey ,
      }
      this.props.getPaymentOption(setModel)
      .then((resp)=>{
        this.setState({
          isLoad:false
        })
      })
      .catch((err)=>{
        this.setState({
          isLoad:false,
          paymentErrorMsg: getMessageFromApiError(err),
          isPaymentErrorVisible: true,
        })
      })
    }
  }
  paymentOption(value){
    this.setState({isLoad:true})
    // this.setState({selectedPayment:value.transactionType, isConfirm:true})
    const paymentHash =
      this.state.paymentHashRedirectToCcaPost == undefined
        ? this.props.paymentHash
        : this.state.paymentHashRedirectToCcaPost;
    const deliveryKey =
      this.state.deliveryKey == undefined ? this.props.deliveryKey : this.state.deliveryKey;

    if (!paymentHash) {
      this.setState({
        isLoad: false,
        paymentErrorMsg: "Payment session expired. Please try again from cart.",
        isPaymentErrorVisible: true,
      });
      return;
    }

    var obj = {
      // "CustomerKey":"",
      "PaymentHash": String(paymentHash),
      "PaymentType": value.transactionType,
    }
    // Keep both keys for backend compatibility across API versions.
    obj["DeliveryKey"] = deliveryKey ? String(deliveryKey) : "";
    obj["ReturnKey"] = deliveryKey ? String(deliveryKey) : "";

    //CCA payment gateway
    /*this.props.getPaymentURLToRedirect(obj)
    .then(res => {
      if(res.value.data.CcaPostPath){
        setTimeout(() => { 
          document.cca_form_online.action = res.value.data.CcaPostPath + "&" + res.value.data.CcaPost
          document.forms["cca_form_online"].submit();
        }, 1000);
      }else{
          this.setState({isLoad:false})
      }
    })
    .catch((err)=>{
      this.setState({
        isLoad:false
      })
    })
    */

    this.props.getAtomPaymentURL(obj)
    .then(res => {
      const data = res?.value?.data;
      const postPath = data && (data.CcaPostPath ?? data.ccaPostPath);
      const postQuery = data && (data.CcaPost ?? data.ccaPost);

      if (postPath) {
        setTimeout(() => {
          try {
            const form =
              document.getElementById('payment_by_atom') ||
              document.forms.namedItem('atom_form_online');
            if (form) {
              const atomForm = form as HTMLFormElement;
              atomForm.method = 'post';
              atomForm.action = String(postPath);

              while (atomForm.firstChild) {
                atomForm.removeChild(atomForm.firstChild);
              }

              const rawQuery = postQuery != null ? String(postQuery) : '';
              if (rawQuery.length) {
                const searchParams = new URLSearchParams(rawQuery);
                let hasParams = false;
                searchParams.forEach((paramValue, paramKey) => {
                  hasParams = true;
                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = paramKey;
                  input.value = paramValue;
                  atomForm.appendChild(input);
                });

                // Some integrations return a prebuilt URL instead of key/value pairs.
                if (!hasParams) {
                  window.location.href = `${postPath}${String(postPath).includes('?') ? '&' : '?'}${rawQuery}`;
                  return;
                }
              }
              atomForm.submit();
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.setState({ isLoad: false });
          }
        }, 1000);
      } else {
        this.setState({ isLoad: false });
      }
    })
    .catch((err) => {
      const backendError =
        err?.response?.data?.title ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Unable to initialize payment. Please try again.";
      this.setState({
        isLoad: false,
        paymentErrorMsg: backendError,
        isPaymentErrorVisible: true,
      });
    });

  }

  render() {
    if (!this.state.hasMounted) {
      return <div className="Card-container" />;
    }

    const { isLoading } = this.props;
    const { isConfirm ,totalAmount,shippingCharge} = this.state;
    const { 
      isEnableCreditCard, isEnableDebitCard, isEnableNetbanking, 
      isEnableUPI1,isEnableUPI2,isEnableUPI3,isEnableUPI4,isEnableUPI5,
      isEnableWallet1,isEnableWallet2,isEnableWallet3
    } = this.props
    var amount = 0
    if(shippingCharge){
      amount = parseInt(totalAmount) + parseInt(shippingCharge)
    }else{
      amount = parseInt(totalAmount)

    }
    
    var cardsNetBanking=[];

    if(isEnableNetbanking){
      if(isEnableDebitCard || isEnableCreditCard){
        cardsNetBanking.push({
           mode:'Credit,Debit & ATM cards',
           image:debitCard,
           paymentType:0,
           transactionType:2
          })
      }
      cardsNetBanking.push({
         mode:'Netbanking',
         image:online,
         paymentType:1,
         transactionType:6
        })
    } 
   
   var cardsNetbankingOption = cardsNetBanking !==undefined && cardsNetBanking.map(
    function (value, index) {
      return (
        <List key={index}   onClick={this.paymentOption.bind(this,value)} className="col-md-12 col-lg-12 mode-list">
          <div className="payment-option-container">
           
            <div className="payment-option-icon">
              <Avatar height='60' width='60' src={value.image} className="paymentIcon" />
            </div>
            
            <div className="main">
                <div className="row">
                   <div className="col-md-12 col-sm-12 col-xs-12" style={{width:'80%'}}>
                       <div className="card-text F3 payOption-txt">{value.mode}</div>
                   </div>
                   <div className="col-md-1 col-sm-1 alignEnd noPadding" style={{width:'20%'}}>
                       <div><i className="fa fa-angle-right" aria-hidden="true"></i></div>
                   </div>
                </div>
            </div>

          </div>
        </List>
      );
    }.bind(this)
  );


    var upiOption=[]
      if(isEnableUPI1){
        upiOption.push({
            mode:'Paytm UPI',
            image:paytm,
            paymentType:3,
            transactionType:7})
       }if(isEnableUPI2){
        upiOption.push({
            mode:'Bhim',
            image:upi,
            paymentType:4,
            transactionType:9})
        }if(isEnableUPI3){
          upiOption.push({
            mode:'Google Pay',
            image:googlePay,
            paymentType:5,
            transactionType:9})
        } 
        if(isEnableUPI4){
          upiOption.push({
            mode:'Phone Pay',
            image:phonePay,
            paymentType:5,
            transactionType:9})
        } 
        if(isEnableUPI5){
          upiOption.push({
            mode:'Pay via UPI',
            image:payViaUPI,
            paymentType:5,
            transactionType:9})
        } 
      var UPI = upiOption !==undefined && upiOption.map(
        function (value, index) {
          return (
            <List key={index}   onClick={this.paymentOption.bind(this,value)} className="col-md-12 col-lg-12 mode-list">
              <div className="payment-option-container">
              
                <div className="payment-option-icon">
                  <Avatar height='60' width='60' src={value.image} className="paymentIcon" />
                </div>
                
                <div className="main">
                    <div className="row">
                      <div className="col-md-11 col-sm-11" style={{width:'80%'}}>
                          <div className="card-text F3 payOption-txt">{value.mode}</div>
                          {value.mode === "Pay via UPI" ?
                          <div style={{color:"#afafaf",fontSize:9,lineHeight:1}}>You need to have registerd UPI ID</div>
                          :null}
                        </div>
                      <div className="col-md-1 col-sm-1 alignEnd noPadding" style={{width:'20%'}}>
                          <div><i className="fa fa-angle-right" aria-hidden="true"></i></div>
                      </div>
                    </div>
                </div>
    
              </div>
          </List>
          );
        }.bind(this)
      );
      var walletOption=[];
      if(isEnableWallet1){
        walletOption.push({
           mode:'Paytm',
           image:paytm,
           info:"Link your paytm wallet to use this payment method",
           paymentType:6,
           transactionType:7
          })
      }
      // if(isEnableWallet2){
      //   walletOption.push({
      //      mode:'Mobilewik',
      //      image:creditCard,
      //      paymentType:7,
      //      transactionType:10})
      //  } 
      // if(isEnableWallet3){
      //   walletOption.push({
      //       mode:'Freecharge',    //name
      //       image:googlePay,      //for image
      //       paymentType:8,        //for payment type
      //       transactionType:8}
      //     )
      //  }

    var Wallets = walletOption !==undefined && walletOption.map(
      function (value, index) {
        return (
          <List key={index}   onClick={this.paymentOption.bind(this,value)} className="col-md-12 col-lg-12 mode-list">
          <div className="payment-option-container">
           
            <div className="payment-option-icon">
              <Avatar height='60' width='60' src={value.image} className="paymentIcon" />
            </div>
            
            <div className="main">
                <div className="row">
                   <div className="col-md-12 col-sm-12" style={{width:'80%'}}>
                       <div className="card-text F3 payOption-txt">{value.mode}</div>
                       <div style={{color:"#afafaf",fontSize:9,lineHeight:1}}>{value.info}</div>
                   </div>
                   <div className="col-md-1 col-sm-1 alignEnd noPadding" style={{width:'20%'}}>
                       <div><i className="fa fa-angle-right" aria-hidden="true"></i></div>
                   </div>
                </div>
            </div>

          </div>
        </List>
        );
      }.bind(this)
    );
    return (

      <>
        <form id="payment_by_ccacard"  action="" method="post" name="cca_form_online" >
          <input type="hidden" name="access_code" value="" />
          <input type="hidden" name="encRequest" value="" />
        </form>

        <form id="payment_by_atom"  action="" method="post" name="atom_form_online" />

        <ErrorDialogBox
          errorMsg={this.state.paymentErrorMsg}
          isErrorDialogVisible={this.state.isPaymentErrorVisible}
          closeDialog={this.closePaymentErrorDialog}
        />

        {isLoading || this.state.isLoad?  <Spinner /> : null }



        <div className="Card-container" style={{overflowY:"auto",marginBottom:30}}>
         
          <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                <div className="card">
                  <div className="card-body cart-card">

                      <div className="flex-row" style={{justifyContent:'flex-end'}}>
                        <div className="card-text F3">Amount</div>
                      </div>
                      <div className="flex-row" style={{lineHeight:'1'}}>
                        <div className="card-text F1">Payment</div>
                        <div className="card-text F1">{amount !== undefined ? '₹ ' + amount  : '₹ '+'0'}</div>

                      </div>
                      {this.state.shippingCharge && this.state.shippingCharge !== '0'  ? 
                      <div className="flex-row" style={{lineHeight:'1'}}>
                        <div className="card-text F1"></div>
                        <div className="card-text F0">{'include shipping'+ ' '+ '₹ ' + this.state.shippingCharge }</div>
                      </div>
                      : null}

       

                  </div>
                </div>
              </div>
          </div>


          <div style={{marginBottom:30}}>
             
              <div className="row" style={{display:"block", padding:'0px 10px'}}>
              {cardsNetbankingOption.length > 0 ?
                <div className="row">
                    <div className="col-md-10 col-sm-10 no-Pd">
                        <div className="card-text heading-styling-pay" >Cards  Netbanking</div>
                    </div>
                  </div>:null} 

                {cardsNetbankingOption}
                
              </div>

              <Divider />
             

              <div className="row" style={{display:"block", padding:'0px 10px'}}>
                {UPI.length > 0 ?
                <div className="row" >
                    <div className="col-md-10 col-sm-10 no-Pd">
                        <div className="card-text heading-styling-pay" >UPI</div>
                    </div>
                  </div>:null} 
                {UPI}
              </div>

              <Divider />
              
               
              <div className="row" style={{display:"block", padding:'0px 10px'}}>
                {Wallets.length > 0 ?
                <div className="row" >
                    <div className="col-md-10 col-sm-10 no-Pd">
                        <div className="card-text heading-styling-pay" >Wallets</div>
                    </div>
                  </div>:null} 
                {Wallets}
              </div>

              <Divider />
            
            
          </div>

        </div>
      </>
    );
  }
}

// #region redux map state and dispatch to props
const mapStateToProps = state => {
  return {
    isEnableCreditCard: state.pay.isEnableCreditCard,
    isEnableDebitCard: state.pay.isEnableDebitCard,
    isEnableNetbanking: state.pay.isEnableNetbanking,

    isEnableUPI1: state.pay.isEnableUPI1,
    isEnableUPI2: state.pay.isEnableUPI2,
    isEnableUPI3: state.pay.isEnableUPI3,
    isEnableUPI4: state.pay.isEnableUPI4,
    isEnableUPI5: state.pay.isEnableUPI5,

    isEnableWallet1: state.pay.isEnableWallet1,
    isEnableWallet2: state.pay.isEnableWallet2,
    isEnableWallet3: state.pay.isEnableWallet3,

    paymentHash: state.pay.paymentHash,
    retailPrice:state.cart.retailPrice,
    isLoading:state.pay.isLoading,
    paymentHashKey:state.cart.paymentHashKey,
    deliveryKey:state.pay.deliveryKey
  };

};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getPaymentURLToRedirect,
      storeRetailPrice,
      getPaymentOption,
      getAtomPaymentURL
    },
    dispatch
  );
};

// #endregion

export default compose(
  connect(mapStateToProps, mapDispatchToProps),withRouter
)(PaymentOption);